import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { hemisphereFromCoordinates, parseManualCoordinates } from '../surveyGeo';

type Props = {
  longitudeText: string;
  latitudeText: string;
};

export function SurveyGpsHemisphereResult({ longitudeText, latitudeText }: Props) {
  const result = useMemo(() => {
    const geo = parseManualCoordinates(longitudeText, latitudeText);
    return geo ? hemisphereFromCoordinates(geo) : null;
  }, [longitudeText, latitudeText]);

  if (!result) return null;

  return (
    <Box
      sx={{ mt: 1.5, p: 1.5, borderRadius: 1, bgcolor: 'action.hover' }}
      data-testid="survey-gps-hemisphere-result"
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Hasil perhitungan South / East
      </Typography>
      <Typography variant="body2" data-testid="survey-gps-latitude-dms">
        Latitude: {result.latitudeDms}
      </Typography>
      <Typography variant="body2" data-testid="survey-gps-longitude-dms">
        Longitude: {result.longitudeDms}
      </Typography>
    </Box>
  );
}
